/***
 * Fast way to geth the lengh of a number
 * by preserve its type
 *
 * @param number
 * @return number
 */
export const getLengthOfNumber = (number: number): number => Math.ceil(Math.log10(number));
